import { onBeforeMount } from 'vue';
import { brand } from 'config';
import { useExperiments } from '@composables/useExperiments';
import { usePageData } from '@composables/usePageData';

const onHeader = () => {
  const { deviceType } = usePageData();
  const { experimentFlags } = useExperiments();

  const isBcom = brand === 'bcom';
  const isPhone = deviceType === 'PHONE';
  const headerHiddenMcomMobileEligible = experimentFlags.isPDPEnhancementKEnabled && isPhone;
  const hiddenClass = isBcom ? 'bcom-hidden' : 'mcom-mobile-hidden-header';

  if (!isPhone && isBcom) return;
  if (!headerHiddenMcomMobileEligible && !isBcom) return;

  const handleScroll = () => {
    const header = document.querySelector('#header');
    if (header === null) return;
    header?.classList.remove(hiddenClass);
    window.scrollTo(0, header.offsetHeight + window.scrollY);
  };

  onBeforeMount(() => {
    const scrollHandler = () => {
      handleScroll();
      window.removeEventListener('wheel', scrollHandler);
      window.removeEventListener('touchstart', scrollHandler);
    };

    window.addEventListener('wheel', scrollHandler, { passive: true });
    window.addEventListener('touchstart', scrollHandler, { passive: true });
  });
};

// eslint-disable-next-line import/prefer-default-export
export default onHeader;
